import type { FeedPageMergeRequest, FeedSegment } from './coverage';
import type { WarmCoverageRange } from './feedMirror';
import { compareSortOrders } from './ids';
import type { SortOrder } from './types';

export function coverageFromMergeRequest(
  request: FeedPageMergeRequest,
  pageSegment: FeedSegment
): WarmCoverageRange[] {
  if (request.kind === 'before' && request.boundarySortOrder) {
    return warmCoverageRange(pageSegment.oldestSortOrder, request.boundarySortOrder);
  }
  if (request.kind === 'after' && request.boundarySortOrder) {
    return warmCoverageRange(request.boundarySortOrder, pageSegment.newestSortOrder);
  }
  return warmCoverageRange(pageSegment.oldestSortOrder, pageSegment.newestSortOrder);
}

export function coverageFromBeforeRead(
  segment: FeedSegment,
  boundary: SortOrder,
  messages: readonly { readonly sortOrder: SortOrder }[],
  count: number
): WarmCoverageRange[] {
  const first = messages[0];
  if (!first) return [];
  return warmCoverageRange(messages.length < count ? segment.oldestSortOrder : first.sortOrder, boundary);
}

export function coverageFromAfterRead(
  segment: FeedSegment,
  boundary: SortOrder,
  messages: readonly { readonly sortOrder: SortOrder }[],
  count: number
): WarmCoverageRange[] {
  const last = messages.at(-1);
  if (!last) return [];
  return warmCoverageRange(boundary, messages.length < count ? segment.newestSortOrder : last.sortOrder);
}

export function coverageFromMessages(
  messages: readonly { readonly sortOrder: SortOrder }[]
): WarmCoverageRange[] {
  const first = messages[0];
  const last = messages.at(-1);
  return first && last ? warmCoverageRange(first.sortOrder, last.sortOrder) : [];
}

export function warmCoverageRange(start: SortOrder, end: SortOrder): WarmCoverageRange[] {
  if (compareSortOrders(start, end) > 0) return [];
  return [{ start, end }];
}
